module.exports = __webpack_public_path__ + "static/media/card_brand_visa.a642f251.svg";